import React, { Fragment, memo, useEffect, useState } from 'react';

import { connect, useDispatch } from 'react-redux';
import { Button } from 'appkit-react';

import NoDataContent from './noDataContent';
import ProjectsListView from './projectsListView';
import ArchiveListView from './archiveListView';
import action from '@flux/action';
import { Radio } from 'antd';
import * as PropTypes from 'prop-types';
import {
  PROJECT_TYPES,
  ProjectTypeFilter,
} from '@modules/projects/projectsList/projectTypeFilter';
import ShowDetailToggle from './showDetailToggle';
import { setSessionStorage } from '@utils/windowUtil';

ProjectTypeFilter.propTypes = { onChange: PropTypes.func };

function ProjectsList(props) {
  const {
    data,
    history,
    saveCreateProjectData,
    clearCompanyName,
    clearProjectDetail,
    clearCustomizedModules,
    accepted,
    fetchArchiveData,
    archiveListData,
    userInfo,
  } = props;

  const [mode, setMode] = useState('active');
  const [dataL, setDataL] = useState(0);
  const [archiveDataL, setArchiveDataL] = useState(null);
  const [initData, setInitData] = useState(true);
  const [initArchiveData, setInitArchiveData] = useState(true);
  const [filter, setFilter] = useState({
    active: PROJECT_TYPES.ALL_PROJECT,
    archive: PROJECT_TYPES.ALL_PROJECT,
  });
  const isInternal = JSON.parse(
    window.localStorage.userInfo || '{}',
  ).isInternal;
  const nonUS = JSON.parse(window.localStorage.userInfo || '{}').nonUS;

  const handleModeChange = (e) => {
    setMode(e.target.value);
    const v = e.target.value;
    if (v !== 'active') {
      // console.log(`archiveDataL:${dataL},data.length:${data.length}`);
      if (dataL !== data.length || !archiveDataL) {
        setDataL(data.length);
        fetchArchiveData();
      }
    } else {
      // console.log(
      //   `archiveDataL:${archiveDataL},archiveListData.length:${archiveListData.length}`,
      // );
      if (archiveDataL !== archiveListData.length) {
        setArchiveDataL(archiveListData.length);
        fetchData();
      }
    }
  };

  if (initData && data.length !== 0) {
    setDataL(data.length);
    setInitData(false);
  }
  if (initArchiveData && archiveListData.length !== 0) {
    setArchiveDataL(archiveListData.length);
    setInitArchiveData(false);
  }

  const dispatch = useDispatch();

  const { fetchData, clearCurrentId, matchBreadCrumb } = props;
  window.SessionStorage.removeItem('projectName');
  useEffect(() => {
    clearCurrentId(history);
    clearCompanyName();
    clearProjectDetail();
    clearCustomizedModules();

    // Terms are fetched once after login in AppContainer; we only read state here
    if (accepted) {
      fetchData();
    }
  }, [accepted]);

  useEffect(() => () => dispatch(action.changeArchiveList([])), []);

  useEffect(() => {
    if (data?.length === 1 && userInfo.isClient) {
      const project = data[0];
      const { projectId, projectName } = project;
      if (projectId) {
        setTimeout(() => {
          setSessionStorage('projectName', projectName);
          setSessionStorage('currentId', projectId);
          history.push(`/project-detail/${projectId}`);
        }, 0);
      }
    }
  }, [data]);

  return (
    <div className="page-wrapper project-list">
      {!Array.isArray(data) || data.length === 0 ? (
        <NoDataContent />
      ) : (
        <Fragment>
          <div className="toolbar-wrapper">
            {isInternal && !nonUS && (
              <Button
                className="create-btn"
                size="lg"
                onClick={() => {
                  saveCreateProjectData({ init: true });
                  history.push('/projects/create');
                }}
              >
                <span className="appkiticon icon-circle-plus-fill a-font-16" />
                New Project
              </Button>
            )}
            {userInfo.isAdmin && <ShowDetailToggle />}

            <div className="archive-tab">
              {isInternal && userInfo.isAdmin && (
                <Radio.Group
                  onChange={handleModeChange}
                  value={mode}
                  buttonStyle="solid"
                  className="role-control"
                >
                  <Radio.Button value="active">Active</Radio.Button>
                  <Radio.Button value="archive">Archive</Radio.Button>
                </Radio.Group>
              )}
              {mode === 'active' ? (
                <ProjectTypeFilter
                  data={data}
                  filter={filter.active}
                  onChange={(value) => {
                    setFilter((prev) => ({ ...prev, active: value }));
                  }}
                />
              ) : (
                <ProjectTypeFilter
                  data={archiveListData}
                  filter={filter.archive}
                  onChange={(value) => {
                    setFilter((prev) => ({ ...prev, archive: value }));
                  }}
                />
              )}
            </div>
          </div>

          {mode === 'active' ? (
            <ProjectsListView
              data={data.filter((e) => {
                if (filter.active === PROJECT_TYPES.ALL_PROJECT) {
                  return true;
                }
                if (filter.active === PROJECT_TYPES.TEST_PROJECTS) {
                  return e.isInternalUseOnly;
                }
                return e.instanceName === filter.active;
              })}
              matchBreadCrumb={matchBreadCrumb}
              userInfo={userInfo}
            />
          ) : (
            <ArchiveListView
              data={archiveListData.filter((e) => {
                if (filter.archive === PROJECT_TYPES.ALL_PROJECT) {
                  return true;
                }
                if (filter.archive === PROJECT_TYPES.TEST_PROJECTS) {
                  return e.isInternalUseOnly;
                }
                return e.instanceName === filter.archive;
              })}
              matchBreadCrumb={matchBreadCrumb}
            />
          )}
        </Fragment>
      )}
    </div>
  );
}

const mapStateToProps = ({ projects, login }) => ({
  data: projects.listData,
  archiveListData: projects.archiveListData,
  saveData: projects.saveData,
  accepted: login.userInfo.accepted,
  userInfo: login.userInfo,
});

const mapDispatchToProps = (dispatch) => ({
  fetchData() {
    dispatch(action.fetchProjectsListData());
  },
  fetchArchiveData() {
    dispatch(action.fetchArchiveListData());
  },

  clearCurrentId(history) {
    window.SessionStorage.removeItem('currentId');
    window.SessionStorage.removeItem('projectName');
    window.SessionStorage.removeItem('systemSettingsFrom');
    history.replace({ ...history.location, state: {} });
    dispatch(action.changeCurrentId(null));
  },
  clearCompanyName() {
    dispatch(action.clearCompanyName());
  },
  saveProjectDetail(projectDetail) {
    dispatch(action.saveProjectDetail(projectDetail));
  },
  matchBreadCrumb(projectName) {
    dispatch(action.matchBreadCrumb(projectName));
  },
  saveCreateProjectData(data) {
    dispatch(action.saveData(data));
  },
  changeLoading(p) {
    dispatch(action.changeLoading(p));
  },
  clearProjectDetail() {
    dispatch(action.clearProjectDetail());
  },
  clearCustomizedModules() {
    dispatch(action.saveCustomizedModules([]));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(memo(ProjectsList));
